import { DEFAULT_PACKS, normalizePacks } from '../config/featurePacks';
import PackAuditService from './PackAuditService';

const STORAGE_KEY = 'safeguardpro_feature_packs_v1';

const readPacks = () => {
  if (typeof window === 'undefined') return { workspaceId: 'default', packs: { ...DEFAULT_PACKS } };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { workspaceId: 'default', packs: { ...DEFAULT_PACKS } };
    const parsed = JSON.parse(raw);
    return {
      workspaceId: parsed.workspaceId || 'default',
      packs: normalizePacks(parsed.packs || {})
    };
  } catch (error) {
    return { workspaceId: 'default', packs: { ...DEFAULT_PACKS } };
  }
};

const writePacks = (data) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  window.dispatchEvent(new Event('packs:updated'));
};

export default class FeaturePackService {
  constructor() {
    this.auditService = new PackAuditService();
  }

  get() {
    return readPacks();
  }

  update(nextPacks, user) {
    const current = readPacks();
    const normalized = normalizePacks(nextPacks || {});
    const payload = {
      workspaceId: current.workspaceId || 'default',
      packs: normalized,
      updatedBy: user?.name || user?.id || 'system',
      updatedAt: new Date().toISOString()
    };
    Object.keys(normalized).forEach((packId) => {
      const before = Boolean(current.packs?.[packId]);
      const after = Boolean(normalized[packId]);
      if (before !== after) {
        this.auditService.log({
          packId,
          from: before,
          to: after,
          updatedBy: payload.updatedBy
        });
      }
    });
    writePacks(payload);
    return payload;
  }

  validateSerialKey(serialKey) {
    return {
      status: 'not_implemented',
      message: 'Serial key validation is not implemented yet.',
      serialKey
    };
  }

  requirePack(packId) {
    const { packs } = readPacks();
    if (!packs?.[packId]) {
      return {
        ok: false,
        error: { code: 'PACK_DISABLED', pack: packId }
      };
    }
    return { ok: true };
  }
}
